// extracted by css-extract-rspack-plugin
export default {"titleSubtext":"titleSubtext-OxMJh_"};